/**
 * Every error code an OpenID Connect provider may return on the authorization endpoint, grouped by
 * what we tell the user about it.
 *
 * The codes are OAuth 2.0's, defined in RFC 6749 §4.1.2.1
 * (https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.2.1), plus the ones added by OpenID
 * Connect Core 1.0 §3.1.2.6 (https://openid.net/specs/openid-connect-core-1_0.html#AuthError).
 *
 * The specs distinguish failures by cause, but a nursery employee can only act on a handful of
 * outcomes, so several codes share a reason. Grouping them here rather than in a switch keeps the
 * closed set and its copy in one place: a code is recognised precisely when it appears below.
 */
export const OPEN_ID_ERROR_CODES_BY_REASON = {
    /** The provider understood the request and refused it */
    accessDenied: ['access_denied', 'consent_required'],
    /** The provider needs the user in front of it before it can authenticate them */
    signInRequired: ['login_required', 'interaction_required', 'account_selection_required'],
    /** Something transient at the provider's end, so retrying is worth it */
    providerUnavailable: ['server_error', 'temporarily_unavailable'],
    /** The request was malformed or unsupported — nothing the user can do about it */
    configuration: [
        'invalid_request',
        'unauthorized_client',
        'unsupported_response_type',
        'invalid_scope',
        'invalid_request_uri',
        'invalid_request_object',
        'request_not_supported',
        'request_uri_not_supported',
        'registration_not_supported',
    ],
};
